/* global posthogProjectToken:readonly, posthogApiHost:readonly */
// The above globals are set in the pages/base.html
import posthog from 'posthog-js'

posthog.init(posthogProjectToken, {
    api_host: posthogApiHost,
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
})
